module.exports = __webpack_public_path__ + "static/media/9.2f1e34e9.jpg";